var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7664,
    cy: 24.7664,
    r: 24.7664,
    fill: "#CB202D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7664 15.875C22.9144 15.8772 21.1389 16.6138 19.8294 17.9234C18.5199 19.2329 17.7832 21.0084 17.781 22.8604C17.7788 24.3738 18.2732 25.8462 19.1883 27.0516C19.1883 27.0516 19.3788 27.3025 19.4099 27.3387L24.7664 33.656L30.1255 27.3355C30.1534 27.3018 30.3446 27.0516 30.3446 27.0516L30.3452 27.0497C31.2599 25.8448 31.754 24.3731 31.7518 22.8604C31.7496 21.0084 31.013 19.2329 29.7034 17.9234C28.3939 16.6138 26.6184 15.8772 24.7664 15.875ZM24.7664 25.4005C24.264 25.4005 23.7729 25.2516 23.3552 24.9725C22.9375 24.6933 22.6119 24.2966 22.4196 23.8325C22.2274 23.3683 22.1771 22.8576 22.2751 22.3648C22.3731 21.8721 22.615 21.4195 22.9703 21.0642C23.3255 20.709 23.7781 20.4671 24.2709 20.3691C24.7636 20.2711 25.2743 20.3214 25.7385 20.5136C26.2026 20.7059 26.5994 21.0314 26.8785 21.4492C27.1576 21.8669 27.3066 22.358 27.3066 22.8604C27.3057 23.5338 27.0378 24.1794 26.5616 24.6556C26.0855 25.1318 25.4398 25.3997 24.7664 25.4005Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.e380c4ca89009555a3466c02050176c1.svg";
export { ForwardRef as ReactComponent };